import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useRef, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { fetchFlag } from "../utils/servers/fetchData";

const DropDownFlag = ({ openMenu, isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const getFlags = async () => {
      const result = await fetchFlag();
      setData(result);
    };
    getFlags();
  }, []);

  // Handle click outside & scroll
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleScroll = () => {
      setIsOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className="language_wrapper"
      ref={dropdownRef}
    >
      <div
        className="selected_flag"
        onClick={toggleDropdown}
      >
        <Image
          width={24}
          height={16}
          priority={false}
          alt="Flag site"
          src="https://www.images.puramas.co/flag-cn.png"
        />
        <span className="lan_name">Cn</span>
        <FaAngleDown className="text-red-500" />
      </div>
      {isOpen && (
        <div className={`language_list`}>
          <ul
            className={`${openMenu ? "bg-[#969696] text-white text-bold" : ""} ${
              isScrolled ? "bg-[#969696]" : ""
            } flag_select_wrapper`}
          >
            {data?.map((elem) => {
              return (
                <li
                  className="flag_item"
                  key={elem.f_id}
                >
                  <Link href={elem.web_link}>
                    <Image
                      width={24}
                      height={16}
                      alt={`Flag ${elem.flag_name}`}
                      src={elem.flag_link}
                      priority={false}
                    />
                    <span>{elem.flag_name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropDownFlag;
